jQuery( ( $ ) => {

	$( 'header' ).sticky( {
		zIndex: 2000,
	} );

	$( '.navbar-toggler' ).click( function() {
		if ( $( this ).hasClass( 'collapsed' ) ) {
			// Menu is about to open (Bootstrap hasn't removed 'collapsed' yet)
			$( '#header-menu' ).one( 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
				function() {
					$( 'header' ).sticky( 'update' );
				} );
		} else {
			// Menu is about to close
			$( '#header-menu' ).one( 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
				function() {
					$( 'header' ).sticky( 'update' );
				} );
		}
	} );
} );